import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';

import SummarySellerTiles from './SellerTiles';

const SummarySellerPanel = () => {
    return (
        <SummarySellerTiles renderHeader="Sprzedawca">
            <Grid container
                  direction="column">
                <Typography variant="subtitle1">
                    Gdańskie Wydawnictwo Oświatowe spółka z ograniczoną odpowiedzialnością sp. k.
                </Typography>
                <span>al. Grunwaldzka 50A, 80-241 Gdańsk</span>
                <Typography variant="caption">
                    NIP: 5841000656 <br />
                    e-mail: <Link href="mailto:zamowienia@gwo.pl">zamowienia@gwo.pl</Link><br />
                    telefon: 58 340 63 63
                </Typography>
            </Grid>
        </SummarySellerTiles>
    );
};

export default SummarySellerPanel;
